import { connect } from 'react-redux';
import { getSubcategorySlug } from 'common/ducks/categories';
import NegativeFeedbackResponses from 'entries/components/negative_feedback_responses';

const mapStateToProps = ({ categories }, { subcatId }) => {
  return {
    subcatSlug: getSubcategorySlug(categories, subcatId)
  };
}

export default connect(mapStateToProps)(NegativeFeedbackResponses);



// WEBPACK FOOTER //
// ./entries/containers/negative_feedback_responses.js